import React from "react";
import { motion } from "framer-motion";

const Experience = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 50,
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <motion.div
      className="experience"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        className="exp-header caveat"
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.1 }}
      >
        Work
      </motion.div>
      <motion.div
        className="exp-rows"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div variants={itemVariants}>
          <section className="exp-content">
            <p className="exp timeline">July 2022 - Present:</p>
            <div className="employericon" text="fintech">
              💰
            </div>
            <div className="exp description">
              <p className="employer">Laybuy, NZ ⇒ Software Engineer</p>
              <p>Frontend Consolidation Project, Infrastructure</p>
              <p>Architecture</p>
              <p>
                Tools: Javascript/Typescript, React, React-native, Vite, Ionic,
                URQL, Zustand, GraphQL, Node, K8s, AWS, Pulumi, Github
                Workflows, Appflow
              </p>
            </div>
          </section>
        </motion.div>
        <motion.div variants={itemVariants}>
          <section className="exp-content">
            <p className="exp timeline">July 2021 - July 2022:</p>
            <div className="employericon" text="fintech">
              💰
            </div>
            <div className="exp description">
              <p className="employer">
                Laybuy, NZ ⇒ Software Engineer in Test » QA Lead
              </p>
              <p>
                Tests, Performance, Infrastructure. Automation Testing, Process
                Improvements, CI/CD
              </p>
              <p>Architecture, Team Building</p>
              <p>
                Tools: React, Jest, Cypress, Docker, Kubernetes, Vitest,
                Cypress, Ionic, React, Capacitor, React Testing Library, AWS,
                Pulumi
              </p>
            </div>
          </section>
        </motion.div>
        <motion.div variants={itemVariants}>
          <section className="exp-content">
            <p className="exp timeline">Dec 2019 - July 2021:</p>
            <div className="employericon" text="fintech">
              🐶
            </div>
            <div className="exp description">
              <p className="employer">ezyVet, NZ ⇒ QA Engineer » QA Lead</p>
              <p>Automation and Manual Testing, API Testing, Team building</p>
              <p>Tools: JS, Cypress, Gitlab, AWS</p>
            </div>
          </section>
        </motion.div>
        <motion.div variants={itemVariants}>
          <section className="exp-content">
            <p className="exp timeline">June 2016 - July 2018:</p>
            <div className="employericon" text="fintech">
              👕
            </div>
            <div className="exp description">
              <p className="employer">
                Nordstrom, IN ⇒ Software Engineer in Test
              </p>
              <p>Automation Testing, Project Test Lead</p>
              <p>Manual Testing, Unit Testing</p>
              <p>
                Tools: Nightwatch.js, Watir, BrowserStack, Google analytics,
                Tealium
              </p>
            </div>
          </section>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default Experience;
